import React from "react";

export const Arrow = ({ className }) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M17.2426 14.4976L13 10.255L8.75736 14.4976" strokeWidth="1.5" />
      <circle cx="13" cy="13" r="12" transform="rotate(180 13 13)" />
    </svg>
  );
};

export default Arrow;
